var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnStoryLine = function SvgIcnStoryLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 1.5C2.42157 1.5 1.75 2.17157 1.75 3V13C1.75 13.8284 2.42157 14.5 3.25 14.5H13.25C14.0784 14.5 14.75 13.8284 14.75 13V3C14.75 2.17157 14.0784 1.5 13.25 1.5H3.25ZM2.75 3C2.75 2.72386 2.97386 2.5 3.25 2.5H13.25C13.5261 2.5 13.75 2.72386 13.75 3V13C13.75 13.2761 13.5261 13.5 13.25 13.5H3.25C2.97386 13.5 2.75 13.2761 2.75 13V3ZM4.75 4.66667C4.47386 4.66667 4.25 4.89052 4.25 5.16667C4.25 5.44281 4.47386 5.66667 4.75 5.66667H11.75C12.0261 5.66667 12.25 5.44281 12.25 5.16667C12.25 4.89052 12.0261 4.66667 11.75 4.66667H4.75ZM4.25 7.83333C4.25 7.55719 4.47386 7.33333 4.75 7.33333H11.75C12.0261 7.33333 12.25 7.55719 12.25 7.83333C12.25 8.10948 12.0261 8.33333 11.75 8.33333H4.75C4.47386 8.33333 4.25 8.10948 4.25 7.83333ZM4.75 10C4.47386 10 4.25 10.2239 4.25 10.5C4.25 10.7761 4.47386 11 4.75 11H8.41667C8.69281 11 8.91667 10.7761 8.91667 10.5C8.91667 10.2239 8.69281 10 8.41667 10H4.75Z",
    fill: "currentcolor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnStoryLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_story_line.05c589ba.svg";
export { ForwardRef as ReactComponent };